<template>
  <v-switch
    :label="data.text"
    v-model="data.value"
    :hint="data.placeholder"
    v-bind="data.attrs"
    persistent-hint
    :hide-details="!(!!data.placeholder)"
  ></v-switch>
</template>

<script>
export default {
  name: "Switcher",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
</style>